module.exports = __webpack_public_path__ + "img/attendance.afd994c4.jpg";